export default __webpack_public_path__ + "static/media/Logo.5e6f86a5.svg";